<template>
    <b-overlay :show="typeLoading || loading" opacity="0.2">

        <b-modal id="result" title="Netsis Aktarım Sonuçları" body-class="p-1" scrollable hide-footer no-close-on-esc no-close-on-backdrop>
            <monthly-score-insert-result :result="result" :current-id="currentResultEmployeeId"></monthly-score-insert-result>
        </b-modal>

        <div class="row px-1 pt-1">
            <div class="col-md-1 mb-1 mb-md-0">
                <select class="form-control" v-model="month">
                    <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                </select>
            </div>
            <div class="col-md-1 mb-1 mb-md-0">
                <select class="form-control" v-model="year">
                    <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                </select>
            </div>
            <div class="col-md-auto mb-1 mb-md-0">
                <select class="form-control bg-img-none" v-model="branchType">
                    <option value="O">Org. Şube</option>
                    <option value="S">SGK Şube</option>
                </select>
            </div>
            <div class="col-md-2 mb-1 mb-md-0" v-if="exitAction == null && branchType == 'O'">
                <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Tüm Org. Şubeler"></v-select-list>
            </div>
            <div class="col-md-2 mb-1 mb-md-0" v-if="exitAction == null && branchType == 'S'">
                <v-select-list :options="sbranches" label="Name" v-model="sbranch" placeholder="Tüm SGK Şubeler"></v-select-list>
            </div>
            <div class="col-md-auto mb-1 mb-md-0">
                <button class="btn btn-success btn-block" v-on:click="getDatas">
                    Sorgula
                </button>
            </div>
        </div>

        <div class="sticky-status border-bottom pt-25">
            <div :class="['date-header text-muted font-weight-bolder px-1 pt-1',{'pb-1':(types || []).length == 0}]">
                <span class="material-icons-round text-secondary">calendar_month</span>
                {{showingMonth >= 10 ? showingMonth : [0,showingMonth].join('')}}/{{showingYear}}
            </div>

            <!-- <div class="mx-75 mb-75 mt-75">
                <div class="type rounded px-50 py-25 d-flex align-items-center d-inline-flex m-25" :class="`type-bg-${type.Color}`" v-for="type in types" :key="type.Code">
                    <div class="d-flex align-items-center justify-content-center font-weight-bolder mr-50" :class="`type-${type.Color}`">{{type.Code}}</div>
                    <span class="pr-25">{{type.Name}}</span>
                </div>
            </div> -->
            <div class="px-1" v-if="(types || []).length">
                <vue-perfect-scrollbar>
                    <div class="d-flex g-25 mb-75 mt-75 w-100" >
                        <div v-for="(type,index) in types" :key="index" class="type d-flex align-items-center py-25 pl-25 pr-50 text-nowrap" :class="`type-bg-${type.Color}`">
                            <div class="d-flex align-items-center justify-content-center font-weight-bolder mr-50" :class="`type-${type.Color}`">{{type.Code}}</div>
                            {{$safe(type,'Name')}}
                        </div>
                    </div>
                </vue-perfect-scrollbar>
            </div>
        </div>

        <!-- <div class="px-1 py-1 d-flex justify-content-between" v-if="exitAction == null">
            <button class="btn btn-danger btn-sm" >
                Hepsini Ön Puantaja Gönder
            </button>
            <button class="btn btn-success btn-sm d-flex align-items-center" >
                <b-spinner small class="mr-50" v-if="exporting"></b-spinner>
                {{ exporting ? "Veriler hazırlanıyor. Lütfen bekleyiniz." : 'Excel Olarak İndir' }}
            </button>
        </div> -->

        <div class="row justify-content-center mx-50 my-1" v-if="exitAction == null">
            <div class="col-md-auto mb-1 mb-md-0">
                <b-dropdown variant="outline-primary" text="İşlemler">
                    <b-dropdown-item v-on:click="editAll" :disabled="(serverData || []).length == 0">Tümünü Ön Puantaja Gönder</b-dropdown-item>
                    <b-dropdown-item v-on:click="exportExcel" :disabled="exporting || anyExceeds">Excel Olarak İndir</b-dropdown-item>
                </b-dropdown>
            </div>
            <div class="col-md-2 mb-1 mb-md-0 ml-auto">
                <select class="form-control" v-model="filter">
                    <option v-for="f in c_filters" :key="f.value" :value="f.value">{{f.name}}</option>
                </select>
            </div>
            <div class="col-md-2 mb-1 mb-md-0">
                <b-input-group class="input-group-merge v-table-search-input ml-25">
                    <template #prepend>
                        <b-input-group-text >
                            <feather-icon icon="SearchIcon"></feather-icon>
                        </b-input-group-text>
                    </template>
                    <b-form-input v-model="searchValue" placeholder="Ara..." ></b-form-input>
                </b-input-group>
            </div>
        </div>

        <vue-perfect-scrollbar tag="div" class="overflow-hidden">
            <table class="table table-sm table-hovered bordered-header mb-1 score-table">
                <thead>
                    <tr>
                        <th class="align-middle text-center">İşlemler</th>
                        <th class="align-middle text-nowrap" v-if="(result || []).length>0">Aktarım Durumu</th>
                        <th class="column-sticky align-middle">Sürücü</th>
                        <th class="align-middle">Org. Şube</th>
                        <th class="align-middle">SGK Şube</th>
                        <th v-for="day in daysOfMonth" :key="day" class="table-vertical-text align-middle">
                            <div>{{day}}</div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(d,index) in c_serverData" :key="d.Employee.Id + index">
                        <td class="text-center">
                            <div class="d-flex g-25 justify-content-center">
                                <!-- <template v-if="canLock">
                                    <button class="btn btn-sm btn-icon btn-flat-danger" v-if="!$safe(d,'Locked')" v-on:click="lockOp(d,true)" :disabled="loading" v-b-tooltip.noninteractive.hover.bottom="'Puantajı Kilitle'">
                                        <feather-icon icon="LockIcon"></feather-icon>
                                    </button>
                                    <button class="btn btn-sm btn-icon btn-flat-danger" v-else v-on:click="lockOp(d,false)" :disabled="loading" v-b-tooltip.noninteractive.hover.bottom="'Puantaj Kilidini Kaldır'">
                                        <feather-icon icon="UnlockIcon"></feather-icon>
                                    </button>
                                </template> -->
                                <button class="btn btn-sm btn-icon btn-flat-secondary" :disabled="$safe(d,'AllDaysLocked') || loading" v-on:click="edit(d)" v-b-tooltip.noninteractive.hover.bottom="'Ön Puantaja Gönder'">
                                    <feather-icon icon="SkipBackIcon"></feather-icon>
                                </button>
                                <!-- <button class="btn btn-sm btn-icon btn-flat-success" v-on:click="saveNetsis(d)" v-b-tooltip.noninteractive.hover.bottom="$safe(d,'Employee.LastNetsisPuantajUpdatePeriod') ? 'Yeniden Netsis\'e Kaydet' : 'Netsis\'e Kaydet'">
                                    <feather-icon icon="SaveIcon"></feather-icon>
                                </button> -->
                                <!-- <button v-if="$safe(d,'Employee.LastNetsisPuantajUpdatePeriod')==month+'/'+year && $safe(d,'Employee.BES')" class="btn btn-sm btn-icon btn-flat-info" v-b-tooltip.noninteractive.hover.bottom="'BES Hesapla'" v-on:click="calculateBes(d)">
                                    <feather-icon icon="ZapIcon"></feather-icon>
                                </button> -->
                            </div>
                        </td>
                        <td class="text-center" v-if="(result || []).length>0">
                            <template v-if="getSaveStatus($safe(d,'Employee')) == true">
                                <b-badge v-on:click="showResult($safe(d,'Employee'))" class="c-pointer" variant="success">Başarılı</b-badge>
                            </template>
                            <template v-else-if="getSaveStatus($safe(d,'Employee')) == false">
                                <b-badge v-on:click="showResult($safe(d,'Employee'))" class="c-pointer" variant="danger">Başarısız</b-badge>
                            </template>
                            <template v-else>
                                <b-badge class="c-pointer" variant="dark">Değişiklik Yapılmadı</b-badge>
                            </template>
                        </td>
                        <td class="text-nowrap column-sticky">
                            <div class="d-flex align-items-center">
                                <span class="material-icons-outlined mr-50 text-secondary" v-b-tooltip.noninteractive.hover.bottom="'Personelin ay içinde birden çok bordrosu var ve SGK günleri 30\'u aşıyor.'" v-if="$safe(d,'DaysLimitExceeded')">warning</span>
                                <span class="material-icons-outlined mr-50 text-secondary" v-b-tooltip.noninteractive.hover.bottom="'İlgili şube ve ay için puantaj kilitli.'" v-if="$safe(d,'AllDaysLocked')">lock</span>
                                <!-- <span class="material-icons-outlined mr-50 text-success" v-b-tooltip.noninteractive.hover.bottom="'Puantaj Netsis\'e kaydedildi.'" v-else-if="$safe(d,'Employee.LastNetsisPuantajUpdatePeriod')==showingMonth+'/'+showingYear">check_circle</span>
                                <span class="material-icons-outlined mr-50 text-muted" v-b-tooltip.noninteractive.hover.bottom="'Puantaj Netsis\'e en son '+$safe(d,'Employee.LastNetsisPuantajUpdatePeriod')+' döneminde kaydedildi.'" v-else-if="$safe(d,'Employee.LastNetsisPuantajUpdatePeriod')">cancel</span>
                                <span class="material-icons-outlined mr-50 text-muted" v-b-tooltip.noninteractive.hover.bottom="'Puantaj Netsis\'e hiç kaydedilmedi.'" v-else>cancel</span> -->
                                {{$safe(d,'Employee.FirstName')}} {{$safe(d,'Employee.LastName')}}
                            </div>
                        </td>
                        <td>
                            {{$safe(d,'OBranch.Name') || '-'}}
                        </td>
                        <td v-b-tooltip.noninteractive.hover.bottom="'Giriş Tarihi: '+$safe(d,'SGKEntryDateStr')">
                            <!-- aaa -->
                            {{$safe(d,'SGKBranch.Name') || '-'}}
                        </td>
                        <template v-for="(day) in daysOfMonth">
                                    <td     class="text-center cell-group" 
                                            :title="day" 
                                            :key="day + index" 
                                            :class="[$safe(d.Days[day],'EmployeeWorkingType.Color') ? ['type',$safe(d.Days[day],'EmployeeWorkingType.Color')].join('-') : null]">
                                        {{$safe(d.Days[day],'EmployeeWorkingType.Code') || "-"}}
                                    </td>
                        </template>
                    </tr>
                    <tr v-if="c_serverData.length == 0">
                        <td class="text-center" colspan="122">Herhangi bir veri bulunamadı.</td>
                    </tr>
                </tbody>
            </table>
        </vue-perfect-scrollbar>
        <div v-if="(serverData || []).length" class="row justify-content-md-between justify-content-center mx-50 mb-50">
            <div class="col-auto mb-1 mb-md-0">
                <div class="d-flex align-items-center text-nowrap">
                    Toplam {{(filteredLength || 0)}} kayıt arasından
                    <select class="form-control form-control-sm mx-50 per-page-select" v-model="perPage">
                        <option v-for="pp in perPages" :key="pp" :value="pp">{{pp}}</option>
                    </select>
                    gösteriliyor.
                </div>
            </div>
            <div class="col-auto mb-1 mb-md-0">
                <b-pagination class="mb-0" v-model="p" :total-rows="((filteredLength || 0))" :per-page="perPage"></b-pagination>
            </div>
        </div>

        <!-- <b-tabs active-nav-item-class="nav-pill-primary" pills nav-wrapper-class="px-1 pt-1">
            <b-tab title="Günlük Bilgi">
                
            </b-tab>
            <b-tab title="Aylık Bilgi">
                <vue-perfect-scrollbar>
                    <table class="table table-sm table-hovered bordered-header mb-1">
                        <thead>
                            <tr>
                                <th class="w-20 column-sticky">Sürücü</th>
                                <th v-for="(title,index) in titles" :key="'th'+title+index" class="w-20 text-nowrap">{{$safe(title,'Name') || '-'}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="($safe(serverFinalData,'EmployeeKYKMs') || []).length">
                                <tr v-for="ek in serverFinalData.EmployeeKYKMs" :key="ek.Employee.Id">
                                    <td class="column-sticky text-nowrap">
                                        {{$safe(ek,'Employee.FullName')}}
                                    </td>
                                    <td v-for="(title,index) in titles" :key="'th'+title+index">
                                        {{valueGetter(ek,title)}}
                                    </td>
                                </tr>
                            </template>
                            <tr v-if="($safe(serverFinalData,'EmployeeKYKMs') || []).length == 0">
                                <td class="text-center" colspan="100">Herhangi bir veri bulunamadı.</td>
                            </tr>
                        </tbody>
                    </table>
                </vue-perfect-scrollbar>
            </b-tab>
        </b-tabs> -->
        <!-- <div class="d-flex flex-column align-items-end pt-50 px-1 pb-1">
            <div class="d-flex flex-column g-50 bg-light-primary p-75 border-primary rounded">
                <div class="d-flex g-50">
                    <v-date-picker class="w-auto" v-model="date" placeholder="Maaşın Ödendiği Tarih"></v-date-picker>
                    <v-executer class="text-nowrap" :loading="saving" :action="save" :disabled="(serverData || []).length == 0" text="Kaydedilmemişleri Netsis'e Kaydet"></v-executer>
                </div>
                <div class="d-flex align-items-center g-50">
                    <span class="material-icons-outlined" v-b-tooltip.bottom="'ssds'">info</span>
                    <span class="text-secondary font-weight-bolder">*Maaş ödenmediyse boş bırakınız.</span>
                </div>
            </div>
        </div> -->
    </b-overlay>
</template>

<script>
import {BOverlay,VBTooltip,BTabs,BTab,BBadge,BSpinner,BPagination,BInputGroup,BInputGroupText,BFormInput,BDropdownItem,BDropdown} from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moment from 'moment'
import Additional from '@/utilities/additional'
import MonthlyScoreInsertResult from './MonthlyScoreInsertResult.vue'

export default {
    components:{
        BOverlay,
        VuePerfectScrollbar,
        BTab,
        BTabs,
        MonthlyScoreInsertResult,
        BBadge,
        BSpinner,
        BPagination,
        BInputGroup,
        BInputGroupText,
        BFormInput,
        BDropdown,
        BDropdownItem
    },
    directives:{
        "b-tooltip":VBTooltip
    },
    props:{
        months:Array,
        types:{
            type:Array,
            default:()=>[]
        },
        typeLoading:{
            type:Boolean,
            default:false
        },
        branches:{
            type:Array,
            default:()=>[]
        },
        sbranches:{
            type:Array,
            default:()=>[]
        },
        exitAction:[Object,null]
    },
    data() {
        return {
            serverData:[],
            serverFinalData:[],
            year:null,
            years:[],
            showingYear:null,
            month:null,
            showingMonth:null,
            loading:false,
            saving:false,
            daysOfMonth:[],
            exporting:false,
            result:[],
            currentResultEmployeeId:null,
            filteredLength:0,
            branch:null,
            p:1,
            perPage:10,
            perPages:[10,20,30,40],
            filter:1,
            searchValue:"",
            date:null,
            sbranch:null,
            branchType:'O'
        }
    },
    mounted(){
        this.getCurrentYear()
        this.configureYears()
        this.getCurrentMonth()
        this.configureDaysOfMonth(Date.now())
        //this.getDatas()
    },
    methods:{
        getSaveStatus(e){
            if(this.result.find(r=> r.Id == e.Id)?.Success != null){
                return this.result.find(r=> r.Id == e.Id)?.Success
            }else return null
        },
        showResult(e){
            this.currentResultEmployeeId = null
            this.currentResultEmployeeId = e.Id || null
            this.$showModal('result')
        },
        getSavedMonthly(){
            return new Promise((resolve,reject)=>{
                EmployeeOperationsApi.Score.SavedMonthly({
                    BranchId:this.branchType == 'O' ? (this.branch?.Id || null) : (this.sbranch?.Id || null),
                    BranchTypeCode:this.branchType,
                    EmployeeId:this.exitAction?.employeeId || null,
                    CollarStatusId:null,
                    Year:this.year,
                    Month:this.month,
                    QueryParam:null,
                })

                // const api = this.branch?.Id != null 
                //             ? EmployeeOperationsApi.Score.SavedMonthlyWithBranch(this.branch.Id,this.month,this.year)
                //             : this.exitAction != null 
                //                 ? EmployeeOperationsApi.Score.SavedMonthlyWithEmployee(this.month,this.year,this.exitAction.employeeId)
                //                 : this.searchValue 
                //                     ? EmployeeOperationsApi.Score.SavedMonthlyByQueryParam(this.month,this.year, this.searchValue)
                //                     : EmployeeOperationsApi.Score.SavedMonthly(this.month,this.year)
                // api
                .then(res=>{
                    this.rBranch = structuredClone(this.branch)
                    resolve(true)
                    this.serverData = res.data
                    let date = moment(this.year+'-'+this.month,'YYYY-MM')
                    this.configureDaysOfMonth(date)
                }).catch(err=>{
                    reject(err)
                })
            })
        },
        getNetsisFinal(){
            return new Promise((resolve,reject)=>{
                EmployeeOperationsApi.Score.NetsisFinal(this.month,this.year).then(res=>{
                    this.serverFinalData = res.data.Data
                    resolve(true)
                }).catch(err=>{
                    reject(err)
                })
            })
        },
        // lockOp(d,lock){
        //     this.loading = true
        //     EmployeeOperationsApi.Score.ChangeLockStatus({
        //         Ids:Object.values(d.Days).map(i => i.DriverScoreId).filter(i => i!= null),
        //         Lock:lock
        //     }).then(res => {
        //         this.$result(res)
        //         this.loading = false
        //         if(res.data.Success){
        //             this.getDatas()
        //         }
        //     }).catch(err => {
        //         this.$result(null,err)
        //         this.loading = false
        //     })
        // },
        // lockAllOp(lock){
        //     const title = lock 
        //         ? 'Tüm puantajları kilitlemek istediğinize emin misiniz?' 
        //         : 'Tüm puantajların kilinidi kaldırma istediğinize emin misiniz?'
        //     const content = lock 
        //         ? `Bu işlem toplam ${(this.serverData || []).length} adet personelin puantajını kilitler ve geri alınamaz.` 
        //         : `Bu işlem toplam ${(this.serverData || []).length} adet personelin puantajının kilidini kaldırır ve geri alınamaz.` 
        //     this.$confirm(title,content).then(res => {
        //         if(res){
        //             this.loading = true
        //             const data = (this.serverData || []).reduce((arr,d) => {
        //                 Object.values(d.Days).forEach(i => {
        //                     arr.push(i.DriverScoreId)
        //                 })
        //                 return arr
        //             },[])
        //             EmployeeOperationsApi.Score.ChangeLockStatus({
        //                 Ids:data.filter(i => i != null),
        //                 Lock:lock
        //             }).then(res => {
        //                 this.$result(res)
        //                 this.loading = false
        //                 if(res.data.Success){
        //                     this.getDatas()
        //                 }
        //             }).catch(err => {
        //                 this.$result(null,err)
        //                 this.loading = false
        //             })
        //         }
        //     })
        // },
        getDatas(callback){
            this.loading = true
            Promise.all([
                this.getSavedMonthly(),
                //this.getNetsisFinal()
            ]).then(()=>{
                this.showingYear = this.year
                this.showingMonth = this.month
                this.result = []
                this.currentResultEmployeeId = null
                if(typeof callback == 'function') callback()
                this.loading = false
            }).catch((err)=>{
                console.log(err)
                this.loading = false
            })
        },
        edit(data){
            this.loading = true
            EmployeeOperationsApi.Score.DeleteSaved({
                Month:this.showingMonth,
                Year:this.showingYear,
                Driver: true,
                Employees:[{
                    EmployeeId:data.Employee.Id,
                    SGKJobNoticeId: data.SGKJobNoticeId || null
                }],
                BranchIds:[data.OBranch?.Id || null].filter(s=>s != null),
            }).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.getDatas()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        editAll(){
            this.$confirm("Tüm personelleri ön puantaja göndermek istediğinize emin misiniz?",`Bu işlem ${(this.serverData || []).length} adet personeli ön puantaja gönderir ve geri alınamaz.`).then(result=>{
                if(result){
                    this.loading = true
                    EmployeeOperationsApi.Score.DeleteSaved({
                        Month:this.showingMonth,
                        Year:this.showingYear,
                        Driver: true,
                        Employees: this.serverData?.map(e=>({
                            EmployeeId:e.Employee.Id,
                            SGKJobNoticeId:e.SGKJobNoticeId || null
                        })),
                        BranchIds: this.serverData?.map(e=>e.OBranch?.Id || null).filter(s=>s != null)
                    }).then(res=>{
                        this.$result(res)
                        this.loading = false
                        if(res.data.Success){
                            this.getDatas()
                        }
                    }).catch(err=>{
                        this.loading = false
                        this.$result(null,err)
                    })
                }
            })
        },
        configureDaysOfMonth(date){
            this.daysOfMonth = []
            Array.from(Array(moment(date).daysInMonth()).keys()).forEach((d,index)=>{
                let _date = moment(date).startOf("month").add(d,'days')
                let _dateForName = _date.format('DD.MM.YYYY')
                this.daysOfMonth.push(_dateForName)
            })
        },
        getCurrentYear(){
            this.year = moment().format('YYYY')
            this.showingYear = this.year
        },
        configureYears(){
            let years = []
            let year = 2015
            while(year <= this.year){
                years.push(year)
                year ++
            }
            this.years = years
        },
        getCurrentMonth(){
            let current = moment().month() + 1
            this.month = this.months.find(m=>m.index == current)?.index || 0
            this.showingMonth = this.month
        },
        valueGetter(ek,title){
            let val = ek.KYKMs.find(k => k.SystemCode == title?.SystemCode)?.Value
            return (val !== "undefined" && val != null) ? val : '-'
        },
        save(){
            this.loading = true
            EmployeeOperationsApi.Score.NetsisInsert({
                    Month:this.showingMonth,
                    Year:this.showingYear,
                    Driver:true,
                    BranchId:this.branch?.Id || null,
                    SalaryPaymentDate:this.date,
                }).then(res=>{
                this.loading = false
                this.$result(res)
                if(res.data.Success){
                    this.getDatas(()=>{
                        this.result = res.data.Data || []
                    })
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        exportExcel(){
            this.exporting = true
            EmployeeOperationsApi.Score.ExcelDriver({
                BranchId:this.branchType == 'O' ? (this.branch?.Id || null) : (this.sbranch?.Id || null),
                BranchTypeCode:this.branchType,
                EmployeeId:this.exitAction?.employeeId || null,
                CollarStatusId:null,
                Year:this.year,
                Month:this.month,
                QueryParam:this.searchValue || null                                    
            }).then(res=>{
                if(res.data.Success){
                    let fileSplt = res.data.Data?.split('.') || []
                    let fileExt = fileSplt[fileSplt.length-1]
                    Additional.GetBlobFile(res.data.Data).then(f=>{
                        Additional.DownloadFile(f.data,['TMS','PUANTAJ',this.month,this.year].join('-')+'.'+fileExt)
                        this.exporting = false
                    }).catch(err=>{
                        this.$result(null,err)
                        this.exporting = false
                    })
                }else{
                    this.$result(res)
                    this.exporting = false
                }
            }).catch(err=>{
                this.$result(null,err)
                this.exporting = false
            })
        },
        calculateBes(d){
            if(d.Employee?.Id){
                this.loading = true
                EmployeeOperationsApi.EmployeeBesCalculate({
                        Month:this.showingMonth,
                        Year:this.showingYear,
                        Driver:true,
                        EmployeeId:d.Employee?.Id || null
                    }).then(res=>{
                    this.loading = false
                    this.$result(res)
                    if(res.data.Success){
                        this.getDatas(()=>{
                            this.result = res.data.Data || []
                        })
                    }
                }).catch(err=>{
                    this.loading = false
                    this.$result(null,err)
                })
            }
        },
        saveNetsis(d){
            if(d.Employee?.Id){
                this.loading = true
                EmployeeOperationsApi.Score.NetsisInsert({
                        Month:this.showingMonth,
                        Year:this.showingYear,
                        Driver:true,
                        SalaryPaymentDate:this.date,
                        EmployeeId:d.Employee?.Id || null,
                    }).then(res=>{
                    this.loading = false
                    this.$result(res)
                    if(res.data.Success){
                        this.getDatas(()=>{
                            this.result = res.data.Data || []
                        })
                    }
                }).catch(err=>{
                    this.loading = false
                    this.$result(null,err)
                })
            }
        },
    },
    computed:{
        titles(){
            return this.serverFinalData 
            ? [].concat.apply([], this.serverFinalData?.EmployeeKYKMs?.map(ek=>ek.KYKMs.map(k=>{
                    return {Name:k.Name,SystemCode:k.SystemCode}
                }))).filter((v,i,s)=> s?.findIndex(it=>it?.Name == v?.Name) == i || false)
            : []
        },
        anyExceeds(){
            return this.serverData.some(d=>d.DaysLimitExceeded == true)
        },
        c_filters(){
            return (this.result || []).length ? [
                {value:1,name:'Tümü'},
                {value:2,name:'Kaydedilmişleri Göster'},
                {value:3,name:'Kaydedilmemişleri Göster'},
                {value:4,name:'Başarısızları Göster'},
                {value:5,name:'Başarılıları Göster'},
            ] : [
                {value:1,name:'Tümü'},
                {value:2,name:'Kaydedilmişleri Göster'},
                {value:3,name:'Kaydedilmemişleri Göster'},
            ]
        },
        c_serverData(){
            let items = this.serverData.filter(d=>{
                if(this.filter == 1) return true
                else if(this.filter == 2) return this.$safe(d,'Employee.LastNetsisPuantajUpdatePeriod') != null || false
                else if(this.filter == 3) return this.$safe(d,'Employee.LastNetsisPuantajUpdatePeriod') == null || false
                else if(this.filter == 4) return this.result.find(r=> r.Id == d.Employee.Id)?.Success == false
                else if(this.filter == 5) return this.result.find(r=> r.Id == d.Employee.Id)?.Success == true
            }).filter(d=> Additional.ToEng(d.Employee.FullName).toLocaleLowerCase().includes(Additional.ToEng(this.searchValue).toLocaleLowerCase()))
            this.filteredLength = items.length
            return items.slice((this.p-1)*this.perPage,this.p*this.perPage)
        },
    }
}
</script>

<style>
.opacity-75{opacity: .75;}
</style>